module.exports = __webpack_public_path__ + "img/img24.d490d1a2.svg";